(function (angular) {
	angular.module('app.offline', []);
}(angular));

